import React from 'react';
import { FIGMA_YELLOW } from './constants';

// Star geometry mirrors the Figma "rating pill" (5031:3413): 16px stars laid
// out 21.33px apart, i.e. a 5.33px gap.
const STAR_SIZE = 16;
const STAR_GAP = 5.33;
const STAR_EMPTY = '#E8E8ED';

// Figma rating star (matches the carousel card's `STAR_SVG_PATH`), drawn in a
// 16x16 viewBox so the rounded points render identically to the mock.
function StarIcon({ color = FIGMA_YELLOW }: { color?: string }) {
  return (
    <svg width={STAR_SIZE} height={STAR_SIZE} viewBox="0 0 16 16" fill={color} style={{ flexShrink: 0 }} aria-hidden="true">
      <path d="M15.9773 6.07492C15.9519 5.98927 15.9029 5.9125 15.836 5.85339C15.769 5.79428 15.6867 5.75522 15.5986 5.7407L10.6386 4.98515L8.41638 0.274035C8.38041 0.192515 8.32151 0.12321 8.24687 0.074557C8.17222 0.0259036 8.08504 0 7.99593 0C7.90683 0 7.81965 0.0259036 7.745 0.074557C7.67035 0.12321 7.61146 0.192515 7.57549 0.274035L5.35327 4.98515L0.393265 5.7407C0.305129 5.75522 0.222865 5.79428 0.155895 5.85339C0.088925 5.9125 0.0399567 5.98927 0.0145984 6.07492C-0.012732 6.16181 -0.0161775 6.25445 0.00462334 6.34313C0.0254242 6.43181 0.0697048 6.51325 0.132821 6.57892L3.73371 10.2465L2.88393 15.4251C2.86874 15.5147 2.87808 15.6067 2.91094 15.6913C2.94381 15.776 2.99898 15.8502 3.0706 15.906C3.14023 15.9597 3.22403 15.9918 3.31168 15.9984C3.39934 16.0051 3.48702 15.9859 3.56393 15.9434L8.00038 13.498L12.4368 15.9434C12.5137 15.9859 12.6014 16.0051 12.6891 15.9984C12.7767 15.9918 12.8605 15.9597 12.9302 15.906C13.0018 15.8502 13.0569 15.776 13.0898 15.6913C13.1227 15.6067 13.132 15.5147 13.1168 15.4251L12.267 10.2465L15.859 6.5807C15.9225 6.51486 15.9669 6.43311 15.9878 6.34408C16.0086 6.25505 16.0049 6.16206 15.9773 6.07492Z" />
    </svg>
  );
}

/**
 * Five-star rating with a fractional last star: a gold star row is clipped to
 * the exact pixel width covering `rating` stars (accounting for the gaps,
 * which a percentage would snap across) and overlaid on a gray row.
 */
export function StarRating({ rating }: { rating: number }) {
  const clamped = Math.max(0, Math.min(5, rating));
  const whole = Math.floor(clamped);
  const frac = clamped - whole;
  const fillWidth = whole * (STAR_SIZE + STAR_GAP) + frac * STAR_SIZE;
  const row = (color: string) => (
    <div style={{ display: 'flex', gap: STAR_GAP }}>
      {Array.from({ length: 5 }).map((_, index) => (
        <StarIcon key={index} color={color} />
      ))}
    </div>
  );
  return (
    <div style={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
      {row(STAR_EMPTY)}
      <div style={{ position: 'absolute', top: 0, left: 0, width: fillWidth, overflow: 'hidden' }}>
        {row(FIGMA_YELLOW)}
      </div>
    </div>
  );
}
